import React, { Component, createRef } from 'react';
import { Button } from 'ui';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const MIN_PAGE_PADDING = 10;

class MicroFeedbackPopover extends Component {
  popoverRef = createRef();

  arrowRef = createRef();

  componentDidMount() {
    this.positionPopover();
    this.positionArrow();
  }

  positionPopover() {
    const { selectionRect } = this.props;
    const { current: popover } = this.popoverRef;
    const { width: popoverWidth } = popover.getBoundingClientRect();

    popover.style.top = selectionRect.top + window.pageYOffset + 'px';

    const centralLeft =
      selectionRect.left + selectionRect.width / 2 - popoverWidth / 2;

    // clamping the left position at the left side of the screen
    if (centralLeft <= MIN_PAGE_PADDING) {
      popover.style.left = MIN_PAGE_PADDING + 'px';
    }

    // clamping the left position at the right side of the screen
    else if (
      centralLeft + popoverWidth + MIN_PAGE_PADDING >
      window.innerWidth
    ) {
      popover.style.left = window.innerWidth - popoverWidth - 10 + 'px';
    }

    // default left placement
    else {
      popover.style.left = centralLeft + 'px';
    }
  }

  positionArrow() {
    const { selectionRect } = this.props;
    const { current: popover } = this.popoverRef;
    const { current: arrow } = this.arrowRef;
    const popoverRect = popover.getBoundingClientRect();
    const selectionMidPoint = selectionRect.left + selectionRect.width / 2;
    const popoverMidPoint = popoverRect.left + popoverRect.width / 2;
    const midPointDelta = selectionMidPoint - popoverMidPoint;
    arrow.style.left = popoverRect.width / 2 + midPointDelta + 'px';
  }

  render() {
    const { onClick } = this.props;
    return (
      <div ref={this.popoverRef} className="MicroFeedbackPopover">
        <div className="MicroFeedbackPopover-content">
          <div className="mb-8">
            <Text variant={TEXT_VARIANTS.BODY_ON_DARK}>
              {t('micro_feedback.send_feedback_question')}
            </Text>
          </div>
          <Button customColor onClick={onClick}>
            {t('micro_feedback.send_feedback')}
          </Button>
        </div>
        <div ref={this.arrowRef} className="MicroFeedbackPopover-arrow" />
      </div>
    );
  }
}

export default MicroFeedbackPopover;
